import { render, staticRenderFns } from "./NotificationRuleActionDetails.vue?vue&type=template&id=74ba4f4a"
import script from "./NotificationRuleActionDetails.vue?vue&type=script&lang=ts"
export * from "./NotificationRuleActionDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports